<header>

  <dx-toolbar class="header-toolbar">
    @if (menuToggleEnabled && !isBase) {
    <dxi-item location="before" widget="dxButton" cssClass="menu-button" [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }">
    </dxi-item>
    }

    <!--AZIONI VELOCI
class="d-lg-none d-none d-lg-blockd-xl-none d-none d-xl-block d-xxl-none d-none d-xxl-block
-->


    <dxi-item location="after" locateInMenu="auto">
      <div *dxTemplate="let data of 'item'">

        @if(!isBase){
        <i id="iconaAlert" class="fa fa-bell fa-2x"></i>
        <span class="badge badge-warning navbar-badge count-bell">{{countAlert}}</span>

        <dx-context-menu [dataSource]="listAlert" [width]="120" target="#iconaAlert"
          showEvent="dxcontextmenu dblclick click" cssClass="allerts">
          <div *dxTemplate="let e of 'item'">
            <div style="padding:10px;">
              @if (e.tipoAlert==='ScadenzaDipendente') {
              <div (click)="goToDipendente(e.dipendente.id)">
                <!--<span class="dx-icon-spinright"></span>-->
                <span class="dx-icon-user"></span> <strong> {{e.dataTermine | date: 'dd/MM/yyyy'}} |
                  {{e.dipendente.nominativo}}</strong>
                <div> {{e.descrizione}}</div>
              </div>
              }
              @if (e.tipoAlert==='ScadenzaArticolo') {
              <div (click)="goToArticolo(e.articolo.id)">
                <span class="dx-icon-smalliconslayout"></span> <strong> {{e.dataTermine | date: 'dd/MM/yyyy'}} |
                  {{e.dettaglio}}</strong>
                <div>{{e.descrizione}}</div>
              </div>
              }

              @if (e.tipoAlert==='ScadenzaMovimento') {
              <div (click)="goToMovimentazioni()">
                <span class="dx-icon-smalliconslayout"></span> <strong> {{e.dataTermine | date: 'dd/MM/yyyy'}} |
                  {{e.dipendente.nominativo}} </strong>
                <div>{{e.descrizione}}</div>
              </div>
              }

              @if (e.tipoAlert==='ScadenzaCustomMatricola') {
              <div (click)="goToArticolo(e.articolo.id)">
                <span class="dx-icon-smalliconslayout"></span> <strong> {{e.articolo.descrizione}}
                  {{e.articoloMatricola.matricola}} </strong>
                <div>{{e.descrizione}}</div>
              </div>
              }

              @if (e.tipoAlert==='ScortaMinima') {
              <div (click)="goToArticolo(e.articolo.id)">
                <span class="dx-icon-smalliconslayout"></span> <strong> Scorta minima
                  {{e.articolo.descrizione}}</strong>
                <div>{{e.descrizione}}</div>
              </div>
              }
              @if(e.tipoAlert==='NuoveProposteGestione'){
              <div (click)="goToProposte()">
                <span class="dx-icon-comment"></span> <strong> {{e.count}}</strong>
                <div>{{e.descrizione}}</div>
              </div>
              }
              @if(e.tipoAlert==='ProposteGestioneNonGestite'){
              <div (click)="goToProposte()">
                <span class="dx-icon-comment"></span> <strong> {{e.count}}</strong>
                <div>{{e.descrizione}}</div>
              </div>
              }
              <!--
                  <span [ngClass]="e.icon"></span>
                  <span *ngIf="e.items" class="dx-icon-spinright"></span> {{e.tipoAlert}} {{e.descrizione}}
                -->
            </div>
          </div>
        </dx-context-menu>
        }
      </div>
    </dxi-item>

    <dxi-item location="after" locateInMenu="auto">
      <div *dxTemplate="let data of 'item'" class="">
        @if(!isBase){
        <dx-drop-down-button text="" [dropDownOptions]="{ width: 230 }" icon="plus" [items]="azioniVeloci"
          (onItemClick)="eseguiAzione($event)"></dx-drop-down-button>
        }
      </div>
    </dxi-item>

    @if (title) {
    <dxi-item location="before" cssClass="header-title" [text]="title">
      <img [src]="logoDitta" [alt]="utente?.infoDitta.denominazione" (click)="goToHome()" height="30">
    </dxi-item>
    }


    <dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
      <div *dxTemplate="let data of 'item'">
        <dx-button class="user-button authorization" width="210px" height="100%" stylingMode="text">
          <div *dxTemplate="let data of 'content'">
            <app-user-panel [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
          </div>
        </dx-button>
      </div>
    </dxi-item>
    <div *dxTemplate="let data of 'menuItem'">
      <app-user-panel [menuItems]="userMenuItems" menuMode="list"></app-user-panel>
    </div>
  </dx-toolbar>
</header>